import Chip from "components/atoms/Chip/Chip";
import { VideoCallParticipant } from "../CreateVideoCall/useVideoCallParticipants";
import { FormattedMessage } from "react-intl";
import { getUserFullName } from "utils";
import { useSelectedLinkContext, useWebUserContext } from "contexts";

export type VideoCallParticipantsProps = {
  participants: VideoCallParticipant[];
  removeParticipant?: (email: string) => void;
};

const VideoCallParticipants = ({ participants, removeParticipant }: VideoCallParticipantsProps): JSX.Element => {
  const { selectedLink } = useSelectedLinkContext();
  const { webUser } = useWebUserContext();

  const tabletParticipant = { email: '', displayedName: getUserFullName(selectedLink.mainUser), isRemovable: false };

  const getDisplayedName = (participant: VideoCallParticipant) => {
    if (participant.email === webUser.email) return 'Vous';
    return participant.displayedName ?? participant.email;
  }

  return  <div className='flex flex-col gap-1w'>
            <h2 className='text-subtitle1'><FormattedMessage id="videoCall.create.participantsList.title" /></h2>
            <div className='flex flex-wrap gap-1w'>
              {[tabletParticipant, ...participants].map((participant) => 
                <Chip key={participant.email} 
                      onDelete={participant.isRemovable && removeParticipant ? () => removeParticipant(participant.email) : undefined}>
                  {getDisplayedName(participant)}
                </Chip>)
              }
            </div>
          </div>
};

export default VideoCallParticipants;